import React, { useState } from "react";
import { connect } from "react-redux";

import "../JournalListing.scss";
import SearchIngredientsForm from "../../recipes/add/searchIngredientsForm";
import SelectIngredientsForm from "../../recipes/add/selectIngredientsForm";

const SelectFoodItem = ({ setSelectedIngredient, setIsRecipe, setIsFoodItem, setToggleAddToJornal, isAdmin }) => {
	const [searchLoading, setSearchLoading] = useState(false);
	const onIngredientSelect = (ingredient) => {
		setSelectedIngredient(ingredient);
	};

	const cancel = () => {
		setSelectedIngredient(null);
		setIsRecipe(false);
		setIsFoodItem(false);
		setToggleAddToJornal(false);
	};

	const onSelect = (event) => event;

	return (
		<React.Fragment>
			<div className="d-flex flex-column min-h-100 flex-fill">
				<div>
					<SearchIngredientsForm onSearch={(event) => setSearchLoading(event)} />
				</div>
				<div className="flex-fill d-flex flex-column">
					<SelectIngredientsForm
						isSearching={searchLoading}
						setIsExists={onSelect}
						onIngredientSelect={onIngredientSelect}
					/>
				</div>
			</div>
			<div className="filter-footer sticky-footer text-right px-0">
				<div className="d-flex flex-row align-items-center w-100 justify-content-between">
					
						<div className="text-center">
							<h5 className="text-primary-dark mt-3">Cannot find an ingredient? </h5>
							{isAdmin ? (
								<a
									href="/nutrition/food-database/add"
									className="btn btn-primary-dark btn-ghost"
									rel="noopener noreferrer"
									target="_blank">
									<i className="icon icon-add-edit" /> Add New Food
								</a>
							) : (
								<a
									href="/nutrition/myfood/add"
									className="btn btn-primary-dark btn-ghost"
									rel="noopener noreferrer"
									target="_blank">
									<i className="icon icon-add-edit" /> Add New Food
								</a>
							)}
						</div>
					<button onClick={cancel} className="btn btn-default">
						Cancel
					</button>
				</div>
			</div>
		</React.Fragment>
	);
};

const mapStateToProps = (state) => {
	return {
		isAdmin: state.Auth.isAdmin
	};
};

const mapDispatchToProps = {};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(SelectFoodItem);
